import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function fileToFormData(file, name) {
  const data = new FormData();
  if (file) {
    data.append('files[]', file, name || 'blob.png');
  }
  return data;
}

export function useUploadImage(wireId) {
  const [state, q] = useAxios({
    url: `/api/v1/wire/${wireId}/image`,
    method: 'POST',
    headers: {
      'content-type': 'multipart/form-data',
    },
  }, { manual: true });
  const executeQuery = (file, name) => q({ data: fileToFormData(file, name) });
  return [state, executeQuery];
}
